import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Stats(_: Props) {
  return (
    <div className={styles.stats}>
      <div className={styles.col}>
        <div className={styles.row}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.value} />
        </div>
        <div className={styles.row}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.value} />
        </div>
        <div className={styles.row}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.value} />
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.row}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.value} />
        </div>
        <div className={styles.row}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.value} />
        </div>
      </div>
    </div>
  );
}

export { Stats };
